import { Backend } from '@/_axios';

export default {
  searchUser(name = '') {
    return Backend.get('/orders/search-user', { params: { full_name: name } });
  },
  searchProduct(name = '') {
    return Backend.get('/orders/search-product', { params: { name: name } });
  },
  searchInvoice(orderId, number = '') {
    return Backend.get(`/orders/${orderId}/items/search-invoice`, { params: { number: number } });
  },
  searchInvoiceAdvance(orderId, number = '') {
    return Backend.get(`/orders/${orderId}/advance-invoices/search`, { params: { number: number } })
  },
  list(params) {
    return Backend.get('/orders/', { params });
  },
  listFilters() {
    return Backend.get('/orders/filters');
  },
  classifiers() {
    return Backend.get('/orders/classifiers');
  },
  editData(id) {
    return Backend.get(`/orders/${id}/edit`);
  },
  update(id, updateData) {
    return Backend.put(`/orders/${id}`, updateData);
  },
  createData() {
    return Backend.get('/orders/create');
  },
  create(createData) {
    return Backend.post('/orders/', createData);
  },
  makeApproval(orderId, approvalData) {
    return Backend.put(`/orders/${orderId}/approvements`, approvalData);
  },
  deleteOrder(orderId) {
    return Backend.delete(`/orders/${orderId}`);
  },
  orderCopy(orderId) {
    return Backend.post(`/orders/${orderId}/copy`);
  },
  attachments(id) {
    return Backend.get(`/orders/${id}/attachments`);
  },
  updateAttachmentsStatus(orderId, updateData) {
    return Backend.post(`/orders/${orderId}/attachments/status`, updateData);
  },
  addAttachment(id, file) {
    return Backend.post(`/orders/${id}/attachments`, file);
  },
  addCommentToAttachment(orderId, attachmentId, comment) {
    return Backend.put(`/orders/${orderId}/attachments/${attachmentId}`, comment);
  },
  deleteAttachment(orderId, attachmentId) {
    return Backend.delete(`/orders/${orderId}/attachments/${attachmentId}`);
  },
  activity(orderId, page) {
    return Backend.get(`/orders/${orderId}/activity`, { params: { page } });
  },
  fileFetcher(url, mimeType) {
    return Backend.get(`${url}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: mimeType,
      }
    });
  },
  items(id) {
    return Backend.get(`/orders/${id}/items`);
  },
  createItem(orderId, createData) {
    return Backend.post(`/orders/${orderId}/items`, createData);
  },
  updateItem(orderId, itemId, updateData) {
    return Backend.put(`/orders/${orderId}/items/${itemId}`, updateData);
  },
  deleteItem(orderId, itemId) {
    return Backend.delete(`/orders/${orderId}/items/${itemId}`);
  },
  factsAndInvoicesList(reqData) {
    const orderId = reqData['orderId'];
    const invoiceId = reqData['invoiceId'] ? reqData['invoiceId'] : null;

    if (invoiceId) {
      return Backend.get(`/orders/${orderId}/items/facts-invoices`, { params: { invoice_id: invoiceId } });
    }
    return Backend.get(`/orders/${orderId}/items/facts-invoices`);
  },
  invoicesAdvanceList(orderId) {
    return Backend.get(`/orders/${orderId}/advance-invoices`);
  },
  updateFact(orderId, itemId, updateData) {
    return Backend.put(`/orders/${orderId}/items/${itemId}/fact`, updateData);
  },
  approveFactAndInvoice(orderId, approveData) {
    return Backend.put(`/orders/${orderId}/items/assign-facts-invoices`, approveData);
  },
  approveInvoiceAdvance(orderId, advanceInvoiceId) {
    return Backend.put(`/orders/${orderId}/advance-invoices/${advanceInvoiceId}/assign`);
  },
  removeInvoiceAdvance(orderId, advanceInvoiceId) {
    return Backend.put(`/orders/${orderId}/advance-invoices/${advanceInvoiceId}/remove`);
  },
  itemSendToBookkeeper(orderId, invoiceId, sendData) {
    return Backend.put(`/orders/${orderId}/items/invoice-payment-approve/${invoiceId}`, sendData);
  },
  itemApproveReview(orderId, invoiceId, sendData) {
    return Backend.put(`/orders/${orderId}/items/approve-invoice-review/${invoiceId}`, sendData);
  },
  itemDeclineReview(orderId, invoiceId, sendData) {
    return Backend.put(`/orders/${orderId}/items/decline-invoice-review/${invoiceId}`, sendData);
  },
  invoiceAdvanceSendForReview(orderId, invoiceAdvanceId) {
    return Backend.put(`orders/${orderId}/advance-invoices/${invoiceAdvanceId}/review`);
  },
  approveInvoiceAdvanceReview(orderId, advanceInvoiceId, sendData) {
    return Backend.put(`/orders/${orderId}/advance-invoices/${advanceInvoiceId}/approve-review`, sendData);
  },
  declineInvoiceAdvanceReview(orderId, advanceInvoiceId, sendData) {
    return Backend.put(`/orders/${orderId}/advance-invoices/${advanceInvoiceId}/decline-review`, sendData);
  },
  invoiceAdvanceSendToBookkeeper(orderId, invoiceAdvanceId) {
    return Backend.put(`orders/${orderId}/advance-invoices/${invoiceAdvanceId}/payment-approve`);
  }
};
